import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import {
  fetchTotemPendingAssignments,
  fetchTotemPendingCount,
  resolveTotemPending,
  TotemPendingWithRelations,
} from "~/services/totemService";

import { TOTEM_MOVEMENTS_QUERY_KEY } from "./useTotemDetail";
import { TOTEMS_QUERY_KEY, TOTEM_STATS_QUERY_KEY } from "./useTotems";

export const TOTEM_PENDING_QUERY_KEY = ["totem-pending"];
export const TOTEM_PENDING_COUNT_QUERY_KEY = ["totem-pending-count"];

export function usePendingAssignments(includeResolved = false) {
  return useQuery<TotemPendingWithRelations[], Error>({
    queryKey: [...TOTEM_PENDING_QUERY_KEY, { includeResolved }],
    queryFn: () => fetchTotemPendingAssignments({ includeResolved }),
  });
}

export function usePendingAssignmentsCount() {
  return useQuery<number, Error>({
    queryKey: TOTEM_PENDING_COUNT_QUERY_KEY,
    queryFn: fetchTotemPendingCount,
  });
}

export function useResolvePending() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      performedBy,
      assignedNow,
      notes,
    }: {
      id: string;
      performedBy: string;
      assignedNow?: number;
      notes?: string;
    }) => resolveTotemPending(id, performedBy, { assignedNow, notes }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TOTEM_PENDING_QUERY_KEY });
      queryClient.invalidateQueries({
        queryKey: TOTEM_PENDING_COUNT_QUERY_KEY,
      });
      queryClient.invalidateQueries({ queryKey: TOTEMS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TOTEM_STATS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: TOTEM_MOVEMENTS_QUERY_KEY });
      toast.success("Pendiente actualizado");
    },
    onError: (error: Error) => {
      toast.error(`Error al resolver pendiente: ${error.message}`);
    },
  });
}
